module.exports = __webpack_public_path__ + "img/logo-solides.a1141c5d.png";